import { Station } from '@mi-front/core';
import { get } from 'lodash';
import { useMemo } from 'react';
import { useStations } from '../../../../../core/stations/hooks/useStations';

export function isLowerthirdEnabled(station: Station): boolean {
  return get(station, 'featuresConfig.videoAnalysis.lowerThird.enabled', false);
}

export function useStationsWithLowerthird() {
  const stations = useStations();

  return useMemo(() => stations.filter(isLowerthirdEnabled), [stations]);
}
